// src/portal/PortalContainerContext.tsx
import {
    createContext,
    useContext,
    useEffect,
    useState,
    ReactNode,
} from "react";

const PortalContainerContext = createContext<HTMLElement | undefined>(
    undefined,
);

export function PortalContainerProvider({ children }: { children: ReactNode }) {
    const [portalContainer, setPortalContainer] = useState<HTMLElement>(
        () => document.body,
    );

    useEffect(() => {
        const storybookContainer = document.getElementById("portal-catcher");
        if (storybookContainer) {
            setPortalContainer(storybookContainer);
        }
    }, []);

    return (
        <PortalContainerContext.Provider value={portalContainer}>
            {children}
        </PortalContainerContext.Provider>
    );
}

export function usePortalContainer(): HTMLElement {
    const portalContext = useContext(PortalContainerContext);
    if (!portalContext) {
        throw new Error(
            "usePortalContainer must be used inside a PortalContainerProvider",
        );
    }
    return portalContext;
}
